import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  updateLaptopResultsPageLaptopsFiltered,
  updateLaptopResultsPageSpecsModal,
  updateLaptopResultsPageCurrentLaptop
} from '../../reducers/laptopResultsPageReducer';
import {sampleLaptopDeals} from '../../lib/laptop';
import reduce from 'lodash/reduce';
import orderBy from 'lodash/orderBy';
import {Icon, Button, Modal} from 'semantic-ui-react';
import {BackButton} from '../../components/BackButton/BackButton';
import './LaptopResultsPage.css';

class LaptopResultsPage extends Component {
  constructor(props) {
    super(props);

    window.mixpanel.track('LaptopResultsPage Visited', {});

    this.handleReferralButtonClick = this.handleReferralButtonClick.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);

    window.scrollTo(0,0);
    let laptops = LaptopResultsPage.filterLaptops(sampleLaptopDeals, this.props.filtersSquished);
    laptops = LaptopResultsPage.sortAndNarrowLaptops(laptops);
    window.mixpanel.track('LaptopResultsPage Results Found', {
      laptops: laptops,
      laptopsLength: laptops.length
    });
    this.props.updateLaptopResultsPageLaptopsFiltered(laptops);
  }

  handleReferralButtonClick(type, data) {
    const dealDetails = data.dealdetails;
    window.mixpanel.track('Referral Clicked', {
      title: dealDetails.title,
      link: dealDetails.link,
      manufacturer: dealDetails.manufacturer,
      model: dealDetails.model,
      store: dealDetails.store,
      price: dealDetails.price
    });
  }

  handleModalOpen(type, data) {
    window.mixpanel.track('Specs Help Clicked', {
    });

    this.props.updateLaptopResultsPageCurrentLaptop(data.dealdetails);
    this.props.updateLaptopResultsPageSpecsModal(true);
  }

  handleModalClose() {
    this.props.updateLaptopResultsPageSpecsModal(false);
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  // accepts capacity in GB
  // returns string in either TB or GB
  static beautifyStorage(capacity) {
    if (capacity >= 1000) {
      return (capacity / 1000.0) + ' TB';
    }
    return capacity + ' GB';
  }

  // accepts array of laptop hardDisks
  // sums up total storage
  static getTotalHardDriveSpace(disksArray) {
    let total = 0;
    for (const drive in disksArray) {
      total += drive.size;
    }
    return total;
  }

  static filterLaptops(laptops, filterObj) {
    return laptops.filter(function (laptop) {
      // ram size
      if (laptop.ram.size < filterObj.ramSize.min ||
          laptop.ram.size > filterObj.ramSize.max) {
        return false;
      }
      // hard drive type (SSD)
      if (filterObj.hardDriveType && laptop.hardDisks[0].type !== filterObj.hardDriveType) {
        return false;
      }
      // (total) hard drive space
      if (LaptopResultsPage.getTotalHardDriveSpace(laptop.hardDisks) < filterObj.hardDriveSpace.min ||
          LaptopResultsPage.getTotalHardDriveSpace(laptop.hardDisks) > filterObj.hardDriveSpace.max) {
        return false;
      }
      // screen size
      if (laptop.screen.size < filterObj.screenSize.min ||
        laptop.screen.size > filterObj.screenSize.max) {
        return false;
      }
      // screen type (IPS)
      if (filterObj.screenType && laptop.screen.panelType !== filterObj.screenType) {
        return false;
      }
      // cpu cores
      if (laptop.cpu.cores < filterObj.cpuCores.min ||
        laptop.cpu.cores > filterObj.cpuCores.max) {
        return false;
      }
      // gpu type (Discrete)
      if (filterObj.gpuType && laptop.gpu.type !== filterObj.gpuType) {
        return false;
      }
      // weight
      if (laptop.weight < filterObj.weight.min ||
        laptop.weight > filterObj.weight.max) {
        return false;
      }
      // touchscreen
      if (filterObj.touchscreen && !laptop.screen.touchscreen) {
        return false;
      }
      // budgets
      // b is an array, eg. [0, 499.99]
      for (const b of filterObj.budgets) {
        if (!reduce(filterObj.budgets, function (status, b) {
          if (laptop.price >= b[0] && laptop.price <= b[1]) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }
      // brands
      for (const b of filterObj.brands) {
        if (!reduce(filterObj.brands, function (status, b) {
          if (laptop.manufacturer.toLocaleUpperCase() === b.toLocaleUpperCase()) {
            return true;
          }
          return status || false;
        }, false)) {
          return false;
        }
      }
      // color (skipping for now)

      return true;
    });
  }

  static sortAndNarrowLaptops(laptops) {
    // algo a: specs, price (decr), discount
    let sortedA = orderBy(
      laptops,
      [
        // specs
        function (o) { return o.cpu.cores; },
        function (o) { return o.gpu.type === 'Discrete'; },
        function (o) { return o.ram.size; },
        function (o) { return o.hardDisks[0].type === 'SSD'; },
        function (o) { return o.screen.panelType === 'IPS'; },
        function (o) { return o.gpu.vram; },
        function (o) { return o.screen.resolution.width * o.screen.resolution.height; },
        // price
        function (o) { return o.price; },
        // discount
        function (o) { return o.discount ? o.discount/(o.price + o.discount) : 0; },
      ],
      [
        // specs
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        // price
        'desc',
        // discount
        'desc'
      ]);
    // algo b: discount, price (decr), specs
    let sortedB = orderBy(
      laptops,
      [
        // discount
        function (o) { return o.discount ? o.discount/(o.price + o.discount) : 0; },
        // price
        function (o) { return o.price; },
        // specs
        function (o) { return o.cpu.cores; },
        function (o) { return o.gpu.type === 'Discrete'; },
        function (o) { return o.ram.size; },
        function (o) { return o.hardDisks[0].type === 'SSD'; },
        function (o) { return o.screen.panelType === 'IPS'; },
        function (o) { return o.gpu.vram; },
        function (o) { return o.screen.resolution.width * o.screen.resolution.height; }
      ],
      [
        // discount
        'desc',
        // price
        'desc',
        // specs
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc'
      ]);
    // algo c: price (incr), discount, specs
    let sortedC = orderBy(
      laptops,
      [
        // price
        function (o) { return o.price; },
        // discount
        function (o) { return o.discount ? o.discount/(o.price + o.discount) : 0; },
        // specs
        function (o) { return o.cpu.cores; },
        function (o) { return o.gpu.type === 'Discrete'; },
        function (o) { return o.ram.size; },
        function (o) { return o.hardDisks[0].type === 'SSD'; },
        function (o) { return o.screen.panelType === 'IPS'; },
        function (o) { return o.gpu.vram; },
        function (o) { return o.screen.resolution.width * o.screen.resolution.height; }
      ],
      [
        // price
        'asc',
        // discount
        'desc',
        // specs
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc',
        'desc'
      ]);

    // take top 3:

    // take turns getting top of each array while removing duplicates
    const retVal = [];
    while (retVal.length < 3 && (sortedA.length || sortedB.length || sortedC.length)) {
      while (sortedA.length && retVal.length < 3) {
        if (retVal.indexOf(sortedA[0]) !== -1) {
          sortedA.shift();
          continue;
        }
        retVal.push(sortedA.shift());
        break;
      }
      while (sortedB.length && retVal.length < 3) {
        if (retVal.indexOf(sortedB[0]) !== -1) {
          sortedB.shift();
          continue;
        }
        retVal.push(sortedB.shift());
        break;
      }
      while (sortedC.length && retVal.length < 3) {
        if (retVal.indexOf(sortedC[0]) !== -1) {
          sortedC.shift();
          continue;
        }
        retVal.push(sortedC.shift());
        break;
      }
    }
    return retVal;
  }

  render() {
    return (
      <div className="Regular-page ui centered grid">
        <div className="three column row">
          <div className="one wide column">
          </div>

          <div className="ten wide column center aligned">

            <div>
              &nbsp;
            </div>

            <BackButton onClick={this.handleBackButtonClick}/>
          </div>

          <div className="one wide column">
          </div>
        </div>

        <div className="three column row">
          <div className="one wide column">
          </div>

          <div className="ten wide column">

            {this.props.laptopsFiltered && this.props.laptopsFiltered.length === 0 &&
            <div className="permutize-item Center-Text">
              <h1>No results</h1>
              <h5>Consider increasing your budget or making your requirements less restrictive.</h5>
            </div>
            }

            <div className="ui divided items">
              {this.props.laptopsFiltered.map(laptopDeal =>
                <div key={`${laptopDeal.store}: ${laptopDeal.title} ${laptopDeal.manufacturer} ${laptopDeal.model}`} className="item permutize-item">
                  <div className="ui medium image">
                    <img src={laptopDeal.pictureLink} alt="result"/>
                  </div>
                  <div className="content">
                    <a className="header" onClick={event => {this.handleReferralButtonClick(event, {dealdetails:laptopDeal})} } target="_blank" rel="noopener noreferrer" href={laptopDeal.link}>
                      {laptopDeal.title}
                    </a>

                    <div className="meta">
                      <div className="price-label special-price-label">
                        ${laptopDeal.price}
                        {
                          laptopDeal.discount ?
                            <h4 className="discount-label">Save ${laptopDeal.discount} instantly</h4> :
                            <span></span>
                        }
                      </div>
                      <a href={laptopDeal.link} target="_blank" rel="noopener noreferrer">
                        <Button primary onClick={this.handleReferralButtonClick} dealdetails={laptopDeal}>
                          <Button.Content visible>
                            {laptopDeal.storeDisplayName} <Icon name='shop' />
                          </Button.Content>
                        </Button>
                      </a>
                      {
                        laptopDeal.storeDisplayName === 'Adorama' ?
                          <span className="no-sales-tax-label"> No sales tax outside NY and NJ</span> :
                          <span></span>
                      }
                    </div>

                    <div className="description">
                      <Button onClick={this.handleModalOpen} dealdetails={laptopDeal}>
                        <Button.Content>
                          What do these specs mean?
                        </Button.Content>
                      </Button><br/>
                      {laptopDeal.screen.size}" {laptopDeal.screen.resolution.width}X{laptopDeal.screen.resolution.height} {laptopDeal.screen.panelType} Screen<br/>

                      {laptopDeal.cpu.clockSpeed}GHZ {laptopDeal.cpu.cores}-Core {laptopDeal.cpu.manufacturer} {laptopDeal.cpu.model} Processor<br/>
                      {laptopDeal.ram.size} GB {laptopDeal.ram.sodimm} RAM<br/>

                      {laptopDeal.gpu.type} {laptopDeal.gpu.manufacturer} {laptopDeal.gpu.model}
                      {laptopDeal.gpu.vram ? <span> {laptopDeal.gpu.vram} GB </span> : <span></span>} Graphics<br/>

                      {LaptopResultsPage.beautifyStorage(laptopDeal.hardDisks[0].size)} {laptopDeal.hardDisks[0].type}
                      {laptopDeal.hardDisks.length > 1 ? <span> + {LaptopResultsPage.beautifyStorage(laptopDeal.hardDisks[1].size)} {laptopDeal.hardDisks[1].type}</span> : <span></span>}<br/>

                      {laptopDeal.weight} lbs<br/>
                    </div>
                    {/*Todo: Implement Additional Details popover*/}
                    {/*<div className="extra">Additional Details</div>*/}
                  </div>



                </div>


              )}
            </div>
          </div>

          <div className="one wide column">
          </div>
        </div>


        <Modal closeIcon size={'mini'} onClose={this.handleModalClose} open={this.props.specsModalVisible}>
          <div className="ui centered grid">
            <div className="three column row">

              <div className="three wide column">
              </div>

              <div className="ten wide column">
                {
                  this.props.currentLaptop && this.props.currentLaptop.screen.panelType === 'IPS' &&
                  <p>
                    <b>IPS Screen:</b> A type of technology that offers superior viewing angles on your screen.
                    A high viewing angle means less color shift when viewing your screen from an angle.
                    This is desirable for watching movies, and gaming.<br/>
                    <b>This laptop is equipped with an IPS screen.</b>
                  </p>
                }
                {
                  this.props.currentLaptop && this.props.currentLaptop.hardDisks[0].type === 'SSD' &&
                  <p>
                    <b>SSD:</b> Solid State Srive. This is where your documents, programs, and photos are stored
                    after the computer shuts down.
                    SSDs have no moving parts and are therefore durable and fast.
                    When shopping for a laptop, SSDs are preferred over HDDs.<br/>
                    <b>This laptop is equipped with an SSD.</b>
                  </p>
                }
                <p>
                  <b>RAM:</b> Random Access Memory. RAM is where programs are stored when the computer is running.
                  The more RAM a computer has, the more programs it can run simultaneously.
                  We recommend at least 4 GB of RAM for basic computing; 8 GB or more for gaming and
                  photo/video editing.<br/>
                  <b>This laptop is equipped with {this.props.currentLaptop && this.props.currentLaptop.ram.size} GB of RAM.</b>
                </p>
                <p>
                  <b>GPU:</b> Graphics Processing Unit. This controls how the graphics are displayed on your screen.
                  There are 2 types: <b>Integrated</b> and <b>Discrete</b>.
                  Integrated is sufficient for most computing needs. However, we recommend a Discrete GPU
                  for gaming and video/photo editing.<br/>
                  <b>This laptop is equipped with a {this.props.currentLaptop && this.props.currentLaptop.gpu.type} GPU.</b>
                </p>
                {
                  this.props.currentLaptop && this.props.currentLaptop.weight <= 4 &&
                  <p>
                    This laptop weighs <b>{this.props.currentLaptop.weight} lbs</b> and is <b>very portable</b>.
                  </p>
                }
              </div>

              <div className="three wide column">
              </div>
            </div>
          </div>
        </Modal>

      </div>
    );
  }
}

export default connect(
  (state) => ({
    filtersSquished: state.laptopQuizPage.filtersSquished,
    laptopsFiltered: state.laptopResultsPage.laptopsFiltered,
    specsModalVisible: state.laptopResultsPage.specsModalVisible,
    currentLaptop: state.laptopResultsPage.currentLaptop
  }),
  {
    updateLaptopResultsPageLaptopsFiltered,
    updateLaptopResultsPageSpecsModal,
    updateLaptopResultsPageCurrentLaptop
  }
)(LaptopResultsPage);


// WEBPACK FOOTER //
// ./src/components/LaptopResultsPage/LaptopResultsPage.js